<template>
    <div>
        tips
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>